
interface AdminHeaderProps {
  onLogout: () => void;
  onChangePassword: () => void;
}

export default function AdminHeader({ onLogout, onChangePassword }: AdminHeaderProps) {
  return (
    <header className="bg-gray-950 border-b border-gray-800 sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center bg-gradient-to-br from-cyan-500 to-fuchsia-500 rounded-lg">
            <i className="ri-disc-line text-white text-base"></i>
          </div>
          <span className="text-white font-bold text-base tracking-wide font-['Montserrat']">
            DJ <span className="text-cyan-400">Admin</span>
          </span>
          <span className="hidden sm:inline-block text-gray-700 text-xs ml-2 border border-gray-800 rounded-full px-2 py-0.5">
            Panel de gestión
          </span>
        </div>

        <div className="flex items-center gap-4">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-gray-400 hover:text-cyan-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-external-link-line text-sm"></i>
            </div>
            Ver web
          </a>
          <button
            onClick={onChangePassword}
            className="flex items-center gap-2 bg-gray-800 hover:bg-gray-700 border border-gray-700 text-gray-300 hover:text-cyan-400 text-sm px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-lock-password-line text-sm"></i>
            </div>
            Contraseña
          </button>
          <button
            onClick={onLogout}
            className="flex items-center gap-2 bg-gray-800 hover:bg-red-900/40 border border-gray-700 hover:border-red-700/50 text-gray-300 hover:text-red-400 text-sm px-4 py-2 rounded-lg transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-logout-box-r-line text-sm"></i>
            </div>
            Cerrar sesión
          </button>
        </div>
      </div>
    </header>
  );
}
